import { render } from "./MoleculeConsumoInternet.vue?vue&type=template&id=7810a5c2&scoped=true&ts=true"
import script from "./MoleculeConsumoInternet.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeConsumoInternet.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeConsumoInternet.vue?vue&type=style&index=0&id=7810a5c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7810a5c2"],['__file',"src/components/molecules/MoleculeConsumoInternet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7810a5c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7810a5c2', __exports__)) {
    api.reload('7810a5c2', __exports__)
  }
  
  module.hot.accept("./MoleculeConsumoInternet.vue?vue&type=template&id=7810a5c2&scoped=true&ts=true", () => {
    api.rerender('7810a5c2', render)
  })

}


export default __exports__